import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import FullCalendarLoader from "../internal/FullCalendarLoader";
import {Calendar, EventDropArg, formatDate} from "@fullcalendar/core";
import {CalendarOptions, EventClickArg, EventInput, FormatDateOptions, Identity, PluginDef} from "@fullcalendar/common";
import * as events from "events";
import {EventResizeDoneArg} from "@fullcalendar/interaction";


export interface FullCalendarProps {
}

@Dce("FullCalendar")
export default class FullCalendar<T extends FullCalendarProps> extends DceComponent<T> {
    protected calendar: Calendar;

    constructor(elem: DceHTMLElement, props: T) {
        super(elem, props);

        FullCalendarLoader.load().then(value => {
            console.log("FullCalendar c", value.Calendar);

            this.elem.style.opacity = '0';

            this.calendar = new value.Calendar(
                this.elem,
                this.getCalendarConfiguration(
                    [value.DayGrid, value.TimeGrid, value.List, value.Interaction]
                )
            );

            this.calendar.render();

            setTimeout(() => {
                this.calendar.updateSize();
                this.elem.style.opacity = '1';
            }, 20);

        });

    }

    public eventChanged(e: {
        id: string,
        date: string,
        allDay: boolean,
        start: string,
        end: string
    }) {

    }

    public eventChangedParse(event: EventInput) {

        let dateFormatSettings: FormatDateOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
            locale: 'sv-SE'
        }

        let a = {
            id: event.id,
            date: formatDate(event.date, dateFormatSettings),
            allDay: event.allDay,
            start: formatDate(event.start, dateFormatSettings),
            end: formatDate(event.end, dateFormatSettings)
        };
        this.eventChanged(a);
    }

    public eventResize(e: EventResizeDoneArg) {
        console.log("RESIZE", e);
        this.eventChangedParse(e.event);
    }

    public eventDrop(e: EventDropArg) {
        console.log("DROP", e);
        this.eventChangedParse(e.event);
    }

    public eventClick(e: EventClickArg) {
        console.log("CLICK", e);
    }

    public fetchEvents(
        arg: {
            start: Date;
            end: Date;
            startStr: string;
            endStr: string;
            timeZone: string;
        },
        successCallback: (events: EventInput[]) => void
    ) {

        successCallback([
            {
                id: 'z1',
                title: "Zadanie",
                start: "2022-12-05",
                classNames: ['fc-type-task'],
                durationEditable: false,
                extendedProps: {
                    context: "Lead http://www.jakas-strona-firmy.pl"
                }
            },
            {
                id: '34',
                title: "Zadanie 2",
                start: "2022-12-05",
                classNames: ['fc-type-task'],
                durationEditable: false,
                extendedProps: {
                    context: "Lead #331"
                }
            },

            {
                id: '3434',
                title: "Spotkanie",
                start: "2022-12-05T11:15",
                end: "2022-12-05T12:30",
                classNames: ['fc-type-meeting'],
                extendedProps: {
                    context: "Lead #331"
                }
            },
            {
                id: '3234',
                title: "telekonferencja",
                start: "2022-12-05T11:45",
                end: "2022-12-05T16:30",
                classNames: ['fc-type-telco'],
                extendedProps: {
                    context: "Lead #331"
                }
            },
            {
                id: '344444',
                title: "Spotkanie",
                start: "2022-12-05T15:15",
                end: "2022-12-05T18:30",
                classNames: ['fc-type-meeting'],
                extendedProps: {
                    context: "Lead #331"
                }
            },
            {
                id: '3465756',
                title: "Spotkanie",
                start: "2022-12-05T11:15",
                end: "2022-12-05T14:30",
                classNames: ['fc-type-meeting'],
                extendedProps: {
                    context: "Lead http://www.jakas-strona-firmy.pl"
                }
            }

        ]);

    }

    public getCalendarConfiguration(plugins: PluginDef[]): CalendarOptions {

        return {
            plugins: plugins,
            snapDuration: '00:15',
            initialView: 'dayGridMonth',
            locale: 'pl',
            allDayText: 'Cały dzień',
            businessHours: {
                dow: [1, 2, 3, 4, 5],
                startTime: '06:00',
                endTime: '23:00'
            },
            eventOrder:'resolved,title',
            headerToolbar: {center: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek,listDay'},
            buttonText: {
                'prev': 'Poprzedni',
                'next': 'Nast\u0119pny',
                'dayGridMonth': 'Miesiąc',
                'timeGridWeek': 'Tydzień',
                'timeGridDay': 'Dzień',
                'listWeek': "Plan tygodnia",
                'listDay': "Plan dnia",

                'today': "Dzi\u015B",
                'month': "Miesi\u0105c",
                'week': "Tydzie\u0144",
                'day': "Dzie\u0144"
            },
            weekText: "Tydz",
            moreLinkText: "więcej",
            noEventsText: "Brak wydarze\u0144 do wy\u015Bwietlenia",
            editable: true,
            firstDay: 1,

            eventTimeFormat: { // like '14:30:00'
                hour: '2-digit',
                minute: '2-digit',
                meridiem: false,
                omitZeroMinute: false
            },

            eventDidMount: arg => {
                console.log("MOUNT", arg);

                let props = arg.event.extendedProps;

                if (props.hasOwnProperty('context')) {
                    let contextDiv = document.createElement('div');
                    contextDiv.classList.add("fc-title-context");
                    contextDiv.innerHTML = props.context;

                    let titleElement = arg.el.querySelector('.fc-event-title');
                    if (titleElement) {
                        titleElement.append(contextDiv);
                    }

                    let t = arg.el.querySelector('.fc-list-event-title');
                    if (t) {
                        t.append(contextDiv);
                    }

                }
                console.log(arg.event.extendedProps)
            },

            dateClick: arg => {
                console.log("DATE CLICK", arg);

                if (arg.view.type == 'dayGridMonth') {
                    this.calendar.gotoDate(arg.date);
                    this.calendar.changeView('listDay');
                }

            },

            eventClick: arg => {
                this.eventClick(arg);
            },

            eventDrop: arg => {
                this.eventDrop(arg);
            },

            eventResize: arg => {
                this.eventResize(arg);
            },
            events: (arg, successCallback, failureCallback) => {
                return this.fetchEvents(arg, successCallback);
            },

        };
    }


}
